import { useQuery } from "@tanstack/react-query";
import { UserProfile } from "@okta/okta-sdk-nodejs";

import { API_PROFILE_URL } from "constants/apiUrls";

import { QueryKey } from "types/queryKey/queryKey";

import useGetApiClient from "./useGetApiClient";

function useGetProfileData() {
  const apiClient = useGetApiClient();

  return useQuery<UserProfile>({
    queryKey: [QueryKey.Profile],
    queryFn: () => {
      return apiClient(API_PROFILE_URL).then((res) => res.json());
    },
    initialData: {},
  });
}

export default useGetProfileData;
